import { render, staticRenderFns } from "./goodStock.vue?vue&type=template&id=7eebbda7&"
import script from "./goodStock.vue?vue&type=script&lang=js&"
export * from "./goodStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7eebbda7')) {
      api.createRecord('7eebbda7', component.options)
    } else {
      api.reload('7eebbda7', component.options)
    }
    module.hot.accept("./goodStock.vue?vue&type=template&id=7eebbda7&", function () {
      api.rerender('7eebbda7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trade/comsTrade/goodStock.vue"
export default component.exports